/** Justificativa da exclusão do financeiro do serviço tomado (10 a 500 caracteres). */
export class ExcluirFinanceiroServicoTomadoRequest {
  justificativa = '';
}
